module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/en-card-drag.a968a8b862b1b598bfb2.gif";